import { onMounted, onUnmounted, watch } from 'vue';
import botsService from '../services/botsService.js';
import { buildUserContextKey, loadUserContext, useUserContext } from './userContext.js';

export function useDesktopBotsPrefetch(visible) {
    if (!globalThis.window?.__CORECRY_DESKTOP__) return;
    let ready = false, started = false, disposed = false;
    const prepare = () => {
        if (!ready || started || !visible.value) return;
        started = true;
        void loadUserContext({ force: true }).then(user => {
            if (!disposed) botsService.prefetchBootstrap(buildUserContextKey(user));
        }).catch(() => { started = false; });
    };
    const onReady = () => { ready = true; prepare(); };
    watch(visible, prepare);
    watch(() => buildUserContextKey(useUserContext().userContext.value), () => { started = false; prepare(); });
    onMounted(() => window.addEventListener('corecry:desktop-ready', onReady));
    onUnmounted(() => { disposed = true; window.removeEventListener('corecry:desktop-ready', onReady); });
}
